export enum dndTypes {
    TILE_FROM_HAND = 'TILE_FROM_HAND',
    TILE_FROM_BOARD = 'TILE_FROM_BOARD',
    TILE_GROUP = 'TILE_GROUP',
    BOARD = 'BOARD',
    HAND = 'HAND',
}

export const tileSize = 40;

export const boardWidth = 144;
export const boardHeight = 144;

export const handHeight = 200;

export const dragLayerRadius = 100;

